<template>
    <div class="block">
        <a href="#" :class=" isLoadText && isLoadPhotos ? 'title open': 'title'" @click.prevent="loadData">Интерьеры и учебные пространства</a>
        <transition name="fade">
        <div class="content" v-if="isLoadText && isLoadPhotos">
            <pre style="background-color: #f3f7fa;color: #484c51; border: none; white-space: pre-wrap; padding: 15px; word-break: break-word;">{{learn_space}}</pre>
            <div>
                <span v-if="photos">
                    <h3>Фотографии лабораторий:</h3>
                        <!--<a v-bind:key="item.id" v-for="item in getPhotosByProject()" :href="item.path" target="_blank" style="margin: 2px 5px; display:inline-block;">-->
                            <!--<img :src="item.path" style="max-width: 250px;" />-->
                        <!--</a>-->
                        <viewer :images="getPhotosByProject()">
                            <img v-for="src in getPhotosByProject()" :src="src.path" :key="src.path" style="max-width: 250px;margin: 2px 5px; display:inline-block;">
                        </viewer>
                </span>
                <span v-else>
                    Загрузка данных...
                </span>
            </div>
        </div>
        </transition>
    </div>
</template>

<script>
    import Axios from 'axios'
    import _ from 'lodash'
    import 'viewerjs/dist/viewer.css'
    export default {
        name: "Equipment",
        data() {
            return {
                learn_space: false,
                isLoadText: false,
                isLoadPhotos: false,
                photos: false,
                projes:['hschool'],
            }
        },
        methods:{

            loadData(){
                this.getDataSingle()
                this.getPhotos()
            },
            getDataSingle(){
                if(!this.isLoadText && !this.text){
                    this.isLoadText = true
                    const path = this.$store.state.api + this.$store.state.apiDataSingle + "?eoId=" + this.$store.state.eoId+
                        "&project=hschool&type=0"
                    const $this = this

                    Axios({
                        method: "get",
                        url: path,
                    }).then((res)=>{
                        if(
                            res.status == 200
                            && res.data.result == "success"
                        ){
                            $this.learn_space = res.data.data.learn_space
                        }
                    })
                }else{
                    this.isLoadText = !this.isLoadText
                }
            },

            getPhotos(){
                if(!this.isLoadPhotos && !this.photos){
                    this.isLoadPhotos = true
                    const path = this.$store.state.api + this.$store.state.apiPhotosEquipment + "?eoId=" + this.$store.state.eoId
                    const $this = this

                    Axios({
                        method: "get",
                        url: path
                    }).then((res)=>{
                        if(
                            res.status == 200
                            && res.data.result == "success"
                        ){
                            $this.photos = res.data.data;
                        }
                    })
                }else{
                    this.isLoadPhotos = !this.isLoadPhotos
                }

            },

            getPhotosByProject(){
                var $this = this
                return _.filter(this.photos, function(o){
                    return o.projectType.altName == $this.$store.state.type
                });
            },
        }
    }
</script>

<style scoped>

</style>
